// The out-of-grid ACTIONS fork for the Components record's subgrid tabs (H100).
// Pattern 340 §2a/§2b (src/blank/PATTERNS.md): a subgrid mounts ACTIONS outside
// the grid, so it forks ActionMenu — and the fork MUST refuse a
// `requiresSelection` entry with no rows ticked, honour `disabled`, and render
// nothing when there are no actions.
import React from "react";
import { Button, Menu, MenuItem } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { bindMenu, bindTrigger, usePopupState } from "material-ui-popup-state/hooks";
import { useSnackbar } from "notistack";

import type { ActionMenuItem } from "../../../components/datagrid/ActionMenu";
import { actionsMenuButtonSx } from "../../../components/dropdownMenuStyles";

interface Props {
  popupId: string;
  actions: ActionMenuItem[];
  selectionCount: number;
}

const SubgridActions: React.FC<Props> = ({ popupId, actions, selectionCount }) => {
  const { enqueueSnackbar } = useSnackbar();
  const popupState = usePopupState({ variant: "popover", popupId });
  if (actions.length === 0) return null;
  return (
    <>
      <Button
        aria-controls={popupId}
        aria-haspopup="true"
        {...bindTrigger(popupState)}
        sx={actionsMenuButtonSx}
        variant="contained"
        endIcon={<KeyboardArrowDownIcon />}
      >
        ACTIONS {selectionCount > 0 ? `(${selectionCount})` : ""}
      </Button>
      <Menu {...bindMenu(popupState)} keepMounted PaperProps={{ sx: { minWidth: 180 } }}>
        {actions.map((action) => (
          <MenuItem
            key={action.name}
            disabled={Boolean(action.disabled)}
            onClick={() => {
              if (action.disabled) return;
              popupState.close();
              if (action.requiresSelection && selectionCount === 0) {
                enqueueSnackbar("Select a row to continue", { variant: "warning" });
                return;
              }
              if (action.preventMultiSelect && selectionCount > 1) {
                enqueueSnackbar(action.multiSelectErrorMessage || "Please select one row only.", {
                  variant: "warning",
                });
                return;
              }
              action.onClick?.();
            }}
          >
            {action.name}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default SubgridActions;
